import Vue from 'vue';

import couponCodeComponent from '../../../components/common/couponCode.vue';

window.addEventListener('load', function () {
  new Vue({
    el: '#vue-app',

    components: {
      'vue-coupon-code': couponCodeComponent
    },

    data: {
      heroInterval: null
    },

    mounted() {
      this.initFadeIn();
      this.initHero();
    },

    methods: {
      // 画面内に入った要素をフェードインさせるinit処理
      initFadeIn: () => {
        const elements = document.querySelectorAll('.fade-in');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const el = entry.target;

                // delay設定
                const delay = el.dataset.delay;
                if (delay) {
                  el.style.transitionDelay = delay + 's';
                }

                el.classList.add('is-visible');
                observer.unobserve(el); // 1回だけ発火
              }
            });
          },
          {
            threshold: 0.2
          }
        );
        elements.forEach((el) => observer.observe(el));
      },

      // Hero の自動スライドショーを設定
      initHero: () => {
        const heroEl = document.querySelector('#hero');

        if (!heroEl) {
          return;
        }

        const HERO_FADE_DURATION_MS = (4.5 + 1.5) * 1000;
        const heroImages = heroEl.querySelectorAll('.lp-hero__image');

        if (heroImages.length <= 0) {
          return;
        }

        let imageIndex = 0;
        function updateSlider() {
          heroImages.forEach((image) => {
            image.classList.remove('active');
          });
          heroImages[imageIndex % heroImages.length].classList.add('active');
          imageIndex++;
        }

        updateSlider();
        this.heroInterval = setInterval(updateSlider, HERO_FADE_DURATION_MS);
      }
    }
  });
});
